import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "input", "results", "form"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
    this.debounceTimer = null
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  handleKeydown(event) {
    if ((event.metaKey || event.ctrlKey) && event.key === "k") {
      event.preventDefault()
      this.open()
    }

    if (event.key === "Escape" && this.isOpen()) {
      event.preventDefault()
      this.close()
    }
  }

  open() {
    if (this.hasDialogTarget) {
      this.dialogTarget.classList.remove("hidden")
      this.inputTarget.value = ""
      this.inputTarget.focus()
      if (this.hasResultsTarget) {
        const frame = this.resultsTarget.querySelector("#command_palette_results")
        if (frame) frame.innerHTML = ""
      }
    }
  }

  close() {
    if (this.hasDialogTarget) {
      this.dialogTarget.classList.add("hidden")
      this.inputTarget.value = ""
    }
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  isOpen() {
    return this.hasDialogTarget && !this.dialogTarget.classList.contains("hidden")
  }

  // Debounced search on input
  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      const frame = this.resultsTarget.querySelector("#command_palette_results")
        if (frame) frame.innerHTML = ""
      return
    }
    this.debounceTimer = setTimeout(() => {
      if (this.hasFormTarget) {
        this.formTarget.requestSubmit()
      }
    }, 200)
  }

  // Navigate results with arrow keys and Enter
  navigate(event) {
    if (!this.hasResultsTarget) return
    const items = this.resultsTarget.querySelectorAll("[data-result]")
    if (items.length === 0) return

    const current = this.resultsTarget.querySelector("[data-result].bg-tavern-raised")
    let index = Array.from(items).indexOf(current)

    if (event.key === "ArrowDown") {
      event.preventDefault()
      index = index < items.length - 1 ? index + 1 : 0
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      index = index > 0 ? index - 1 : items.length - 1
    } else if (event.key === "Enter") {
      event.preventDefault()
      if (current) {
        current.click()
        this.close()
      }
      return
    } else {
      return
    }

    items.forEach(item => item.classList.remove("bg-tavern-raised"))
    if (items[index]) {
      items[index].classList.add("bg-tavern-raised")
      items[index].scrollIntoView({ block: "nearest" })
    }
  }
}
